import script from "./UserUsage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserUsage.vue?vue&type=script&setup=true&lang=js"

import "./UserUsage.vue?vue&type=style&index=0&id=95e02148&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95e02148"]])

export default __exports__